import { format } from 'date-fns'
import { Check } from 'lucide-react'
import { Link } from 'react-router'

import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { type Reminder, reminderAction, useCompleteReminder } from '@/models/userReminder'

export function ReminderDetailDialog({
  reminder,
  open,
  onOpenChange,
}: {
  reminder: Reminder | null
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  const completeMutation = useCompleteReminder()
  // Same CTA as the reminder email/toast: view the lead, start the follow-up, …
  const cta = reminder ? reminderAction(reminder) : null

  const handleComplete = () => {
    if (!reminder) return
    completeMutation.mutate(reminder.id, { onSuccess: () => onOpenChange(false) })
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Reminder</DialogTitle>
        </DialogHeader>
        {reminder && (
          <div className="flex flex-col gap-3">
            <p className="text-md">{reminder.message}</p>
            <p className="text-sm text-neutral-500">
              {format(new Date(reminder.reminderDate), 'EEEE, MMM d, yyyy · h:mm a')}
            </p>
            {cta && (
              <div>
                <Button asChild variant="link" className="p-0 text-sm">
                  <Link to={cta.to} onClick={() => onOpenChange(false)}>
                    {reminder.lead ? `View lead: ${reminder.lead.name}` : cta.label}
                  </Link>
                </Button>
              </div>
            )}
          </div>
        )}
        {reminder && !reminder.completedAt && (
          <DialogFooter>
            <Button onClick={handleComplete} disabled={completeMutation.isPending} className="text-md">
              <Check className="mr-2 size-4" />
              Complete
            </Button>
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  )
}
